export default function (groupid) {
  switch (groupid) {
    case 'levels':
    case 'imagery':
    case 'basemap':
      return true
  }

  // Any group that has the word 'imagery' in it will do too
  if (groupid.match(/imagery/)) {
    return true
  }
}
